import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { GainLossLayout } from '../gain-loss-layout';
import { UnrealizedCapitalTableContent } from './unrealized-capital-table-content';
import { AllocationsGainLossEnum } from '../../../../../../models/enums/allocations-gain-loss-enum';
import { RealizedCapitalTableContent } from './realized-capital-table-content';
import { Switcher } from '../../../../switcher/switcher';

enum CapitalGainLossModeEnum {
    Unrealized = 'unrealized',
    Realized = 'realized',
}

export const CapitalGainLossTable: React.FC = observer(() => {
    const { t } = useTranslation();
    const [mode, setMode] = useState<CapitalGainLossModeEnum>(CapitalGainLossModeEnum.Unrealized);
    const isRealized = mode === CapitalGainLossModeEnum.Realized;

    const typeKey = isRealized ? 'realized-capital' : 'unrealized-capital';
    const switcherOptions = [
        { value: CapitalGainLossModeEnum.Unrealized, label: t('pages.index.unrealized') },
        { value: CapitalGainLossModeEnum.Realized, label: t('pages.index.realized') },
    ];

    return (
        <GainLossLayout
            gainTitle={t(`layout.tables.allocations.${typeKey}.gain.title`)}
            gainTooltip={t(`layout.tables.allocations.${typeKey}.gain.tooltip`)}
            lossTitle={t(`layout.tables.allocations.${typeKey}.loss.title`)}
            lossTooltip={t(`layout.tables.allocations.${typeKey}.loss.tooltip`)}
            extra={
                <Switcher
                    value={mode}
                    size={'large'}
                    options={switcherOptions}
                    activeColor="primary"
                    onChange={(value) => setMode(value)}
                />
            }
            gainContent={
                isRealized ? (
                    <RealizedCapitalTableContent type={AllocationsGainLossEnum.Gain} />
                ) : (
                    <UnrealizedCapitalTableContent type={AllocationsGainLossEnum.Gain} />
                )
            }
            lossContent={
                isRealized ? (
                    <RealizedCapitalTableContent type={AllocationsGainLossEnum.Loss} />
                ) : (
                    <UnrealizedCapitalTableContent type={AllocationsGainLossEnum.Loss} />
                )
            }
        />
    );
});
